var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnToggleSwipeProspect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "15px",
    viewBox: "0 0 11 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btnToggleSwipeProspect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.43278443,0.44749658 C6.50899889,0.447499218 7.47913465,1.14996031 7.89045346,2.22705872 C8.30177228,3.30415714 8.07319076,4.54356416 7.31138221,5.36687934 C6.54957367,6.19019452 5.40471364,6.43511751 4.41107984,5.98734883 C3.41744603,5.53958015 2.77091377,4.48738857 2.77320359,3.32180575 C2.77320199,2.55842852 3.05358748,1.82640644 3.55251897,1.28719239 C4.05145046,0.747978337 4.72794059,0.44586891 5.43278443,0.44749658 L5.43278443,0.44749658 Z M0.107964072,13.5381669 C0.107964072,13.5381669 -0.457904192,7.32990424 5.71571856,7.53827633 C5.71571856,7.53827633 10.7745808,7.0173461 10.7689222,13.5381669 C8.36828502,14.1127223 6.5891968,14.4 5.43165749,14.4 C4.22009395,14.4 2.44552948,14.1127223 0.107964072,13.5381669 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "btnToggleSwipeProspect",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnToggleSwipeProspect);
export default __webpack_public_path__ + "static/media/btnToggleSwipeProspect.82807def7c3ae9c0d6caf323b6b98bad.svg";
export { ForwardRef as ReactComponent };